import { render } from "./order-not-found.vue?vue&type=template&id=561ae948&ts=true"
import script from "./order-not-found.vue?vue&type=script&lang=ts"
export * from "./order-not-found.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__